import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-badge-alt',
  templateUrl: './badge-alt.component.html',
  styleUrls: ['./badge-alt.component.scss']
})
export class BadgeAltComponent {
  @Input() text: string = '';
  @Input() iconSrc?: string;
  @Input() backgroundColor: string = '#E5F6FD';
  @Input() textColor: string = '#1E5974';
}

